import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
    selector: '[message-host]',
    standalone: false
})
export class BotatoChatMessageDirective {
    constructor(public viewContainerRef: ViewContainerRef) {
    }
}
